<template>
  <div class="whs-detail-icons">
    <div
      v-for="amenity in amenities"
      :key="amenity"
      class="whs-icon-left whs-detail-icon"
      :class="amenityIcon(amenity)"
    >{{ amenityName(amenity) }}</div>
  </div>
</template>

<script>
export default {
  name: 'DetailIcons',
  props: {
    amenities: {
      type: Array,
      required: true
    }
  },
  methods: {
    amenityIcon(amenity) {
      return 'whs-icon-' + amenity;
    },
    amenityName(amenity) {
      const i18n = {
        'private-bathroom': 'Собственная ванная комната',
        'non-smoking': 'Для некурящих',
        window: 'Окно',
        hairdryer: 'Фен',
        mirror: 'Зеркало',
        shower: 'Душ',
        sofa: 'Диван',
        wardrobe: 'Гардероб',
        'air-conditioning': 'Кондиционер',
        'blackout-blinds': 'Окно с затемненными шторами',
        iron: 'Утюг',
        toiletries: 'Туалетные принадлежности',
        'addon-service': 'Дополнительные услуги',
        'no-window': 'Без окна',
        fridge: 'Холодильник',
        kitchen: 'Кухня',
        'kitchen-stuff': 'Кухонные принадлежности',
        microwave: 'Микроволновка',
        soundproofing: 'Звукоизоляция',
        tea: 'Чайник',
        telephone: 'Телефон',
        tv: 'Телевизор',
        safe: 'Сейф',
        'extra-bed': 'Дополнительная кровать',

        accessible: 'Для гостей с ограниченными возможностями',
        bathrobe: 'Халат',
        bath: 'Ванна'
      };

      return i18n[amenity] || amenity;
    }
  }
};
</script>

<style scoped>
.whs-detail-icons {
  display: flex;
  flex-wrap: wrap;
  margin: 8px 0 -2px;
  max-height: 68px;
  overflow: hidden;
}
.whs-detail-icons .whs-icon-left {
  display: flex;
  align-items: center;
  border: 1px solid var(--color-bg-dark);
  font-size: 12px;
  line-height: 18px;
  padding-right: 8px;
  padding-left: 4px;
  margin: 2px;
  border-radius: 24px;
}
.whs-detail-icons .whs-icon-left:before {
  margin: 2px 8px 2px 2px;
  color: var(--color-text-5);
  font-size: 18px;
  display: flex;
  width: 24px;
  height: 24px;
  text-align: center;
  align-items: center;
  justify-content: center;
}
.whs-detail-icon:before {
  content: '\f058';
}
.whs-icon-internet:before {
  content: '\f1eb';
}
.whs-icon-parking:before {
  content: '\f540';
}
.whs-icon-meal:before {
  content: '\f2e7';
}
.whs-icon-pets:before {
  content: '\f6d3';
}
.whs-icon-spa:before {
  content: '\f593';
}
.whs-icon-air-conditioning:before {
  content: '\f2dc';
}
.whs-icon-smoking:before {
  content: '\f48d';
}
.whs-icon-busyness:before {
  content: '\f685';
}
.whs-icon-transfer:before {
  content: '\f207';
}
.whs-icon-kids:before {
  content: '\f1ae';
}
.whs-icon-hairdryer:before {
  content: '\f72e';
}

.whs-icon-private-bathroom:before {
  content: '\f2cd';
}
.whs-icon-shower:before {
  content: '\f2cc';
}
.whs-icon-toiletries:before {
  content: '\f71e';
}
.whs-icon-towels:before {
  content: '\f70e';
}
.whs-icon-tv:before {
  content: '\f26c';
}
.whs-icon-wardrobe:before {
  content: '\f0db';
}
.whs-icon-non-smoking:before {
  content: '\f54d';
}
.whs-icon-window:before {
  content: '\f2d0';
}
.whs-icon-mirror:before {
  content: '\f2bd';
}
.whs-icon-sofa:before {
  content: '\f4b8';
}
.whs-icon-blackout-blinds:before {
  content: '\f2d0';
}
.whs-icon-iron:before {
  content: '\f552';
}

.whs-icon-addon-service:before {
  content: '\f067';
}
.whs-icon-no-window:before {
  content: '\f410';
}
.whs-icon-fridge:before {
  content: '\f0db';
}
.whs-icon-kitchen:before {
  content: '\f0f4';
}
.whs-icon-kitchen-stuff:before {
  content: '\f2e7';
}
.whs-icon-microwave:before {
  content: '\f838';
  font-family: 'Font Awesome 5 Pro';
  font-weight: 400;
}
.whs-icon-soundproofing:before {
  content: '\f6a9';
}
.whs-icon-tea:before {
  content: '\f517';
}
.whs-icon-telephone:before {
  content: '\f552';
}
.whs-icon-tv:before {
  content: '\f26c';
}
.whs-icon-extra-bed:before {
  content: '\f236';
}
.whs-icon-safe:before {
  content: '\f023';
}
.whs-icon-accessible:before {
  content: '\f193';
}
.whs-icon-bathrobe:before {
  content: '\f553';
}
.whs-icon-bath:before {
  content: '\f2cd';
}
</style>